import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import xslFile from "./xslt/FELData.xsl";
import styles from './FELInterpreter.module.css';

export default function FELInterpreter(props){
    const {onSuccessData} = props;
    const inputFile = useRef();
    const [xsl,setXsl] = useState({loading:true,xsl:''});
    const [FELdata,setFELdata] = useState({ready:false, payload: null});
    const [draggingData,setDraggingData] = useState(
        {
            overArea: false,
            overWindow: false,
        }
    );
    function escapeSpecialChars(jsonString) {
        return jsonString.replace(/[$]/g,"").replace("&amp;","&").replace("&lt;","<").replace("&gt;",">").replace(/[\\\"\/\b\f\n\r\t]/g, " ").replace(/[\u0000-\u001f\u007f-\u009f]/g, "");
    }
    function onDragEnter(evde){
        setDraggingData({...draggingData,overWindow:true});
        evde.preventDefault();
    }
    function onDragLeave(evl){
        evl.preventDefault();
        setDraggingData({...draggingData,overWindow:false});
    }
    function onDragOver(evdo){
        evdo.preventDefault();
        setDraggingData({...draggingData,overWindow:true});
    }
    function onDrop(evdr){
        setDraggingData({...draggingData,overWindow:false});
        evdr.preventDefault();  
    }
    function draggingOverArea(evd){
        evd.preventDefault(); 
        evd.stopPropagation();
        setDraggingData({...draggingData,overArea:true});
    }
    function endDraggingOverArea(evd){
        evd.preventDefault();
        setDraggingData({...draggingData,overArea:false});
    }
    function dropOverArea(evd){
        evd.preventDefault();
        evd.stopPropagation();
        setDraggingData({overWindow: false,overArea:false});
            const dT = new DataTransfer();
            if (evd.dataTransfer.items) {
                // Use DataTransferItemList interface to access the file(s)
                [...evd.dataTransfer.items].forEach((item, i) => {
                // If dropped items aren't files, reject them
                    if (item.kind === 'file') {
                        const file = item.getAsFile();
                        if (i==0) dT.items.add(file);
                    }
                });
            } else {
                // Use DataTransfer interface to access the file(s)
                [...evd.dataTransfer.files].forEach((file, i) => {
                    if (i==0) dT.items.add(file);
                });
            }
        
        inputFile.current.files = dT.files;
        inputFile.current.dispatchEvent(new Event('change', { bubbles: true}));
    }
    useEffect(()=>{
        axios({
            url: xslFile, 
            method: 'GET',
            //responseType: 'blob'
        }).then((response) => {
            let parser = new DOMParser();
            setXsl({loading:false,xsl:parser.parseFromString(response.data, "text/xml")});
        }).catch((error)=>{
            setXsl({loading:false,error:true,xsl:null});
        });
        if (!document.fileupBlockedDrop){
            window.addEventListener('dragenter',onDragEnter,false);
            window.addEventListener('dragover',onDragOver,false);
            window.addEventListener('dragleave',onDragLeave,false);
            window.addEventListener('dragend',onDragLeave,false);
            window.addEventListener('drop',onDrop,false);
            document.fileupBlockedDrop = true;
        }


    },[]);
    function transformFile(file){
       
        let reader = new FileReader();
        reader.readAsText(file);
        reader.onload = function (){
            //console.log(reader.result);
            let parser = new DOMParser();
            let xmlDoc = parser.parseFromString(reader.result, "text/xml")
            const xsltProcessor = new XSLTProcessor();
            xsltProcessor.importStylesheet(xsl.xsl);
            const fragment = xsltProcessor.transformToFragment(xmlDoc, document);
            let FELjson =  new XMLSerializer().serializeToString( fragment ).replace(/\n/g,"");
            console.log("Transformation result",(FELjson));
            if (onSuccessData){

                let i=0;
                //let regex = /<json_scape(.*?)>(.*?)<\/json_scape>/gi;
                let regex = /#json_scape#(.*?)#end\:json_scape#/gi;
                let match = regex.exec(FELjson);
               while (match != null) {
                    console.log(match); // this will log the string between the tags
                    FELjson=FELjson.replaceAll(match[0].toString(),'"'+escapeSpecialChars(match[1].toString())+'"');
                    console.log('replace no.'+i.toString(),FELjson);
                    match = regex.exec(FELjson);
                    i++;
                    if (i>100) match = null;
                }
                console.log('final json',FELjson);
                onSuccessData({FELData: JSON.parse(FELjson.replace(/[\u0000-\u001F\u007F-\u009F]/g, "")), FELFile: file});
                
            }
            inputFile.current.value = null;
        };
        reader.onerror = function() {
            //console.log(reader.error);
        };
        
    }
    function handleInputFileChange(ev){
        if (ev.target.files[0]){
            setFELdata({...FELdata,loading:true});
            transformFile(ev.target.files[0]);
        }
    };
    
    return <div>
        {
            (xsl.loading==true)? "Cargando ...":
            (!xsl.error)?
            <div className={styles.uploadarea +" "
            +(
                (draggingData.overWindow===true)? 
                    styles.draggingoverwindow
                :(
                    (draggingData.overArea===true)? 
                        styles.draggingoverarea
                    :'' 
                )
            )} onClick={(evc)=>inputFile.current.click()} onDragOver={draggingOverArea} onDragEnter={draggingOverArea} onDragEnd={endDraggingOverArea} onDrop={dropOverArea}>
                <input ref={inputFile} type="file" onChange={handleInputFileChange} className={styles.inputcontrol} accept=".xml" />
                Por favor, arrastre y suelte su archivo <br /> o haga click acá para buscar y subir su archivo FEL en formato XML 
            </div>:
            <div>Error.</div>
        }
    </div>;
}